import { Outlet } from 'react-router-dom';
import { useScreenInfo } from 'hooks';
import {
  DrawerProvider,
  Main,
  MaterialDrawer,
  ReturnConsignmentList,
  ReturnFilter,
} from 'components';
import { ReturnDetailsProvider } from './contexts';
import * as S from './styles';

export function ExchangeAndReturnPage() {
  const { isMobile } = useScreenInfo();

  return (
    <Main>
      <DrawerProvider>
        <S.Wrapper>
          <ReturnDetailsProvider>
            {isMobile ? (
              <>
                <MaterialDrawer position="right">
                  <S.DetailsSection>
                    <Outlet />
                  </S.DetailsSection>
                </MaterialDrawer>

                <S.ConsignmentsSection>
                  <ReturnFilter />

                  <ReturnConsignmentList />
                </S.ConsignmentsSection>
              </>
            ) : (
              <>
                <S.ConsignmentsSection>
                  <ReturnFilter />

                  <ReturnConsignmentList />
                </S.ConsignmentsSection>

                <S.DetailsSection>
                  <Outlet />
                </S.DetailsSection>
              </>
            )}
          </ReturnDetailsProvider>
        </S.Wrapper>
      </DrawerProvider>
    </Main>
  );
}
